import { Link, Stack, Tooltip, Typography, type SxProps } from "@mui/material";
import type React from "react";
import { Links, type TaskItemStatus } from "src/constants";
import type { ParentTeamDto } from "src/http";
import { isWhitespace } from "../textEditor";
import { TaskItemStatusPicker } from "./TaskItemStatusPicker";

interface Props {
  taskItemGuid: string;
  taskItemTeam: ParentTeamDto | undefined | null;
  taskItemDescription: string;
  taskItemStatus: TaskItemStatus;
  target?: React.HTMLAttributeAnchorTarget;
  onClick?: (e: React.MouseEvent) => void;
  sx?: SxProps;
}

const TaskItemLabel = (props: Props) => {
  return (
    <Stack direction="row" sx={{ ...props.sx }}>
      <TaskItemStatusPicker
        taskItemGuid={props.taskItemGuid}
        status={props.taskItemStatus}
        ownerUserGuids={[]}
        variant="button"
        disabled
      />
      <Tooltip
        title={
          <Typography>
            {props.taskItemTeam && (
              <>
                <strong>{props.taskItemTeam.name}</strong>
                <span> : </span>
              </>
            )}
            <Link href={Links.TaskItemDetail(props.taskItemGuid)} target={props.target}>
              {props.taskItemDescription}
            </Link>
          </Typography>
        }
        placement="right"
      >
        <Link href={Links.TaskItemDetail(props.taskItemGuid)} target={props.target} onClick={props.onClick}>
          {props.taskItemDescription == null || isWhitespace(props.taskItemDescription) ? (
            <Typography variant="placeholder">Nothing here yet.</Typography>
          ) : (
            <Typography>{props.taskItemDescription}</Typography>
          )}
        </Link>
      </Tooltip>
    </Stack>
  );
};

export { TaskItemLabel };
